import React from 'react';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { RolesService, GroupingsService } from '../../services';

@connect(state => {
  return {
    currentGrouping: state.currentGrouping.currentGrouping
  }
})
class RoleView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      roleId: props.match.params.roleId,
      role: null
    };
  }

  componentDidMount() {
    RolesService.get(this.state.roleId, true).then(response => {
      this.setState({ role: response.role });

      if (response.role.roleType.token === 'access_role') {
        GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
          this.setState({
            grouping: this.getSelectedOption(response.groupings)
          });
        }).catch(error => {
          console.error(error);
          this.state.localErrorHandler(error.message);
        });
      }
    }).catch(error => {
      console.error(error); // TODO handle error
    });
  }

  getSelectedOption(groupings) {
    if (this.state.role.deviceGroupingMatch === '%') {
      return groupings[0].options[0].label;
    }

    return groupings.map(grouping => {
      let foundOption = grouping.options.filter(option => option.fqn === this.state.role.deviceGroupingMatch.replace('%', ''));
      return foundOption && foundOption.length > 0 ? foundOption[0].label : null;
    });
  }

  render() {
    if (this.state.role && (this.state.grouping || this.state.role.roleType.token !== 'access_role')) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              {
                this.state.role.roleType.token == 'access_role' ?
                <PageTitle
                  title={`${i18next.t(`role-types.${this.state.role.roleType.token}`)} : ${this.state.role.name}`}
                  subTitle={this.state.role.description}
                  backLinkWithParams= {{
                    link: {
                      pathname: "/admin/roles",
                      search: backLinkSearch,
                      roleType: this.state.role.roleType
                    }
                  }} /> :
                  <PageTitle
                  title={`${i18next.t(`role-types.${this.state.role.roleType.token}`)} : ${this.state.role.name}`}
                  subTitle={this.state.role.description}
                  backLinkWithParams= {{
                    link: {
                      pathname: "/admin/roles",
                      search: backLinkSearch,
                      roleType: this.state.role.roleType
                    }
                  }}
                  editLinkWithParams={{
                    link: {
                      pathname: `/admin/roles/edit/${this.state.role.id}`,
                      uiroute: '/admin/roles/edit/:roleId',
                      roleType: this.state.role.roleType,
                      state: {
                        backLinkSearch: backLinkSearch
                      }}
                  }} />
              }              
            </div>
            {
            this.state.role.roleType && this.state.role.roleType.token === 'action_role' ? (
                <div className="op-content-box">
                  <div className="panel">
                    <ul className="list-inline clearfix remove-margin-bottom">
                      <li className="pull-left"><h4 className="remove-margin-bottom">{i18next.t('pages.roles.templates')}</h4></li>
                    </ul>
                    <hr />
                    <TemplatesList templates={this.state.role.actionRoleTemplates.sort((a,b) => {return a.sortOrder - b.sortOrder})}/>
                  </div>
                  <div className="panel">
                    <ul className="list-inline clearfix remove-margin-bottom">
                      <li className="pull-left"><h4 className="remove-margin-bottom">{i18next.t('pages.roles.screens')}</h4></li>
                    </ul>
                    <hr />
                    <RoutesList routes={this.state.role.uiRoutes} templates={this.state.role.actionRoleTemplates} />
                  </div>
                </div>
            ) : null
            }

            {
              this.state.role.roleType && this.state.role.roleType.token === 'access_role' ? (
                  <div className="op-content-box">
                    <h4>{i18next.t('pages.roles.group-data-access')}</h4>
                    <hr />
                    {i18next.t('pages.roles.device-group-match')}: { this.state.grouping }
                  </div>
              ) : null
            }

            {
              this.state.role.roleType && this.state.role.roleType.token === 'group_role' ? (
                <div className="op-content-box"><MembersList members={this.state.role.users} /></div>
              ) : null
            }
          </div>
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }

}

class RoutesList extends React.Component {

  constructor(props) {
    super(props);

    let enabledRoutes = this.props.routes;

    this.props.templates.forEach(template => {
      template.uiRoutes.forEach(uiRoute => {
        if (!enabledRoutes.find(route => route.id === uiRoute.id)) {
          enabledRoutes.push(uiRoute);
        }
      });
    });

    this.state = {
      enabledRoutes
    }
  }

  renderGrantedBy(data) {
    let grantedBy = i18next.t('pages.roles.this-role');

    this.props.templates.forEach(template => {
      for (let i = 0; i < template.uiRoutes.length; i++) {
        if (template.uiRoutes[i].id === data.original.id) {
          grantedBy = template.name;
          break;
        } 
      }
    });

    return <span>{grantedBy}</span>
  }

  render() {
    // TODO roll these up by parent
    return (
        <div className="react-table-custom">
          <ReactTable
            className="-striped -highlight"
            data={this.state.enabledRoutes}
            showPaginationTop
            defaultSorted={[{
              id: 'uiRouteGroup.name',
              desc: false
            },{
              id: 'priority',
              desc: false
            }]}
            columns={[
                          {
                            Header: i18next.t('table-headers.granted-by'),
                            accessor: "template",
                            Cell: cell => this.renderGrantedBy(cell),
                            minResizeWidth: 50
                          },
                          {
                            Header: i18next.t('table-headers.group'),
                            accessor: "uiRouteGroup.name",
                            Cell: cell => cell.value ? <span>{i18next.t(`menus.from-router.${cell.value}`)}</span> : <span></span>,
                            sortable: true,
                            minResizeWidth: 50
                          },          
                          {
                          Header: i18next.t('table-headers.menu-group'),
                          accessor: "parentTitle",
                          Cell: cell => cell.value ? <span>{i18next.t(`menus.from-router.${cell.value}`)}</span> : <span></span>,
                          sortable: true,
                          minResizeWidth: 50
                        },
                        {
                          Header: i18next.t('table-headers.screen-title'),
                          accessor: "title",
                          Cell: cell => cell.value ? <span>{i18next.t(`menus.from-router.${cell.value}`)}</span>: <span></span>,
                          sortable: true,
                          minResizeWidth: 50
                        },
                        {
                          Header: i18next.t('table-headers.description'),
                          accessor: "description",
                          sortable: true,
                          minResizeWidth: 50,
                          style:{ 'whiteSpace': 'unset'}
                        }, 
                      ]}
          />
        </div>
    );
  }
}

  class TemplatesList extends React.Component {
    constructor(props) {
      super(props);
    }

    render() {
      return (
        <div className="react-table-custom">
          <ReactTable
            className="-striped -highlight"
            data={this.props.templates}
            showPaginationTop
            columns={[
              {
                Header: i18next.t('table-headers.name'),
                accessor: "name",
                sortable: true,
                minResizeWidth: 50
              },          
              {
              Header: i18next.t('table-headers.description'),
              accessor: "description",
              sortable: true,
              minResizeWidth: 50
            }]}
          />
        </div>
      )
    }
  }

  class MembersList extends React.Component {

    constructor(props) {
      super(props);
    }
  
    render() {
      return (
          <div className="react-table-custom">
            <ReactTable
              className="-striped -highlight"
              data={this.props.members}
              showPaginationTop
              columns={[
                            {
                              Header: i18next.t('table-headers.username'),
                              accessor: "username",
                              sortable: true,
                              minResizeWidth: 50
                            },          
                            {
                            Header: i18next.t('table-headers.first-name'),
                            accessor: "firstName",
                            sortable: true,
                            minResizeWidth: 50
                          },
                          {
                            Header: i18next.t('table-headers.last-name'),
                            accessor: "lastName",
                            sortable: true,
                            minResizeWidth: 50
                          }
                        ]}
            />
          </div>
      );
    }
}

export default RoleView;
